module.exports = __webpack_public_path__ + "static/supplierbg2-e0d6c50831a16fb7b4156a157d06d5b1.jpg";